import { TranslateService } from "@ngstack/translate";
import { Component, OnInit, Inject } from "@angular/core";
import { MatTableDataSource, MAT_DIALOG_DATA, MatDialogRef} from "@angular/material";
import { StudentService } from "src/app/services/http/business/student/student.service";

@Component({
  selector: 'app-course-details',
  templateUrl: './course-details.component.html',
  styleUrls: ['./course-details.component.css'],

})
export class CourseDetailsComponent implements OnInit {

  dataSource = new MatTableDataSource();

  displayedColumns: string[] = [
    "typeOfScore",
    "score",
  ];

 

  constructor(  
     public translate: TranslateService,
     private studentService: StudentService,
     private dialog: MatDialogRef<CourseDetailsComponent>,
     @Inject(MAT_DIALOG_DATA) public data: any
     ) { }
 
     ngOnInit() {
      this.refresh();
    }

  refresh() {
        this.studentService.getMarkStudentSTU(this.data).subscribe(res => {
          this.dataSource = null;
          this.dataSource = res;
        });
      }

    onNoClick() {
      this.dialog.close();
    }
}
